import React from "react";
import {
  StationActions,
  StationActionsProps,
} from "Components/OperatorSidePanel/components/StationActions/StationActions";
import {
  InteractionPaneWrapper,
  CallVehicleButtonStyled,
  EmptyErrorStyled,
  MapViewStyled,
} from "./styles";

/**
 * Wrapper component that uses the original StationActions with custom styles
 */
export const StationActionsWithCustomStyles: React.FC<StationActionsProps> = (
  props
) => {
  return (
    <StationActions
      {...props}
      customStyles={{
        InteractionPaneWrapper,
        CallVehicleButtonStyled,
        EmptyErrorStyled,
        MapViewStyled,
      }}
    />
  );
};

export default StationActionsWithCustomStyles;
